import React, { useState } from 'react';
import { useCurrency } from '../../utils/currency';
import './CurrencyWidget.css';

function CurrencyWidget() {
  const { mode, setMode, rates, source } = useCurrency();
  const [open, setOpen] = useState(false);

  const paralleleRate = typeof rates.parallele === 'number'
    ? rates.parallele
    : rates.parallele;

  return (
    <div className="currency-widget">
      <button
        className="currency-widget-toggle"
        onClick={() => setOpen(!open)}
        title="Taux de change"
      >
        <span className="currency-flag">€</span>
      </button>

      {open && (
        <div className="currency-widget-panel glass-card">
          <div className="currency-panel-header">
            <h4>Taux de change EUR/DZD</h4>
            <button className="currency-panel-close" onClick={() => setOpen(false)}>&times;</button>
          </div>

          <div className="currency-options">
            <button
              className={`currency-option ${mode === 'officiel' ? 'active' : ''}`}
              onClick={() => setMode('officiel')}
            >
              <div className="currency-option-header">
                <span className="currency-option-icon">🏛️</span>
                <span className="currency-option-title">Taux officiel</span>
              </div>
              <div className="currency-option-rate">
                1 € = {Number(rates.officiel).toFixed(2)} DZD
              </div>
              <div className="currency-option-source">
                Banque d'Algerie
              </div>
            </button>

            <button
              className={`currency-option ${mode === 'parallele' ? 'active' : ''}`}
              onClick={() => setMode('parallele')}
            >
              <div className="currency-option-header">
                <span className="currency-option-icon">🔄</span>
                <span className="currency-option-title">Square Port-Said</span>
              </div>
              <div className="currency-option-rate">
                1 € = {Math.round(paralleleRate)} DZD
              </div>
              <div className="currency-option-source">
                devisesquare.com
              </div>
            </button>
          </div>

          <div className="currency-disclaimer">
            {source === 'api' ? '✓ Taux mis a jour' : '⏳ Taux en cache'}
            {' · '}Indicatifs, non contractuels.
          </div>
        </div>
      )}
    </div>
  );
}

export default CurrencyWidget;
